// Breakpoint pixel values mirroring `_breakpoints.scss`. Keep these in sync
// with the SCSS source when either changes.
export const XS1 = 320;
export const XS2 = 375;
export const XS3 = 420;
export const XS4 = 480;
export const XS5 = 560;

export const MD1 = 640;
export const MD2 = 768;
export const MD3 = 834;

export const LG1 = 1024;
export const LG2 = 1280;
export const LG3 = 1366;
export const LG4 = 1440;
export const LG5 = 1600;

// Matches the SCSS `responsive(null, $md1)` mixin, which uses `$size - 1px`.
// Use with `useMediaQuery` to detect viewports narrower than the $md1 breakpoint.
export const BELOW_MD1_QUERY = `(max-width: ${MD1 - 1}px)`;

// Matches the SCSS `responsive(null, $lg1)` mixin (`$lg1 - 1px`).
export const BELOW_LG1_QUERY = `(max-width: ${LG1 - 1}px)`;
